import React, { Component } from "react";
import "./i18n";
import { withTranslation } from "react-i18next";
import Tabs from "./Components/Tabs";
import ResetPassword from "./Components/ResetPassword";
import ContactCenter from "./Components/ContactCenter";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCC: false,
      showResetPassword: false,
      showActivation: false,
      defaultNumber: "",
      relatedNumbers: [],
    };
  }

  setShowCC = (param) => {
    this.setState({
      showCC: param,
    });
  };

  setShowActivation = (param) => {
    console.log(" inside setShowActivation : " + param);
    this.setState({
      showActivation: param,
    });
  };

  setDefaultNumber = (param) => {
    console.log(" inside setDefaultNumber : " + param);
    this.setState({
      defaultNumber: param,
    });
  };

  setUserType = (param) => {
    console.log(" inside setUserType : " + param);
    this.setState({
      userType: param,
    });
  };

  setShowResetPassword = (param, userName) => {
    this.setState({
      showResetPassword: param,
      userName: userName,
    });
  };

  setRelatedNumbers = (param) => {
    this.setState({
      relatedNumbers: param,
    });
  };

  render() {
    return (
      <div className="App">
        {!this.state.showCC &&
          !this.state.showResetPassword && (
            <Tabs
              data={this.state.data}
              setShowCC={this.setShowCC}
              setShowResetPassword={this.setShowResetPassword}
              userType={this.state.userType}
              defaultNumber={this.state.defaultNumber}
            />
          )}
        {this.state.showCC && (
          <ContactCenter
            setShowCC={this.setShowCC}
            setShowResetPassword={this.setShowResetPassword}
            setShowActivation={this.setShowActivation}
            userName={this.props.userName}
          />
        )}
        {!this.state.showCC &&
          this.state.showResetPassword && (
            <ResetPassword
              userName={this.state.userName}
              setShowResetPassword={this.setShowResetPassword}
            />
          )}
      </div>
    );
  }
}
export default withTranslation()(App);
